import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getFestivalSeries } from '../../redux/actions/festival-overview-api';
import { pushInUrlQuery } from 'react-url-query';
import { FestivalOverviewAppState } from '../../classes/redux-states';
import { Day } from '../../classes/Day';

export interface ExternalItems {
    dayName: string;
    active: boolean;
}

export interface StateToProps {
    emptyDayList: string[];
    currentDay: string;
}

export interface DispatchToProps {
    getFestivalSeries: (day: string) => any;
     
}

type DayListProps = ExternalItems & DispatchToProps & StateToProps;

export class DayItemComponent extends React.Component<DayListProps, null> {
    constructor(props: DayListProps) {
        super(props);
        this.getFestivalSeriesForDay = this.getFestivalSeriesForDay.bind(this);
        this.isEmptyDay = this.isEmptyDay.bind(this);
        this.setupClasses = this.setupClasses.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.dayButtonClickEvent = this.dayButtonClickEvent.bind(this);
        this.updateMobileDropdown = this.updateMobileDropdown.bind(this);
        this.updateQueryString = this.updateQueryString.bind(this);
    }

    dayButtonClickEvent(event) {
        var dayButtons = document.querySelectorAll('.season-overview-navigation-item');
        for (var i = 0; i < dayButtons.length; i++) {
            if (dayButtons[i].classList.contains("active")) {
                dayButtons[i].classList.remove("active");
                break;
            }
        }
        event.target.classList.add("active");
        this.updateQueryString()
        this.updateMobileDropdown(event.target.innerText);
        this.scrollToTop();
        this.getFestivalSeriesForDay();
    }

    updateQueryString() {
        pushInUrlQuery('day', this.props.dayName);
    }

    updateMobileDropdown(day: string) {
        var dayDropdown = document.getElementById("dayListMobile") as HTMLSelectElement;
        for (var i = 0; i < dayDropdown.options.length; i++) {
            if (dayDropdown.options[i].value.substring(0, 3).toUpperCase() == day) {
                dayDropdown.selectedIndex = i;
            }
        }
    }

    scrollToTop() {
        var topOfApp = document.querySelector('[data-festival-overview-page]');
        topOfApp.scrollIntoView(true);
    }

    getFestivalSeriesForDay() {
        this.props.getFestivalSeries(this.props.dayName)
    }
    
    setupClasses() {
        if (this.props.currentDay.toUpperCase() === this.props.dayName.toUpperCase()) {
            return "season-overview-navigation-item active";
        }
        else {
            return "season-overview-navigation-item";
        }
    }

    isEmptyDay() {
        for (var i = 0; i < this.props.emptyDayList.length; i++) {
            if (this.props.emptyDayList[i] === this.props.dayName) {
                return true;
            }
        }
        return false;
    }

    

    render() {
        return (
            <button type="button" className={this.setupClasses()} onClick={this.dayButtonClickEvent} disabled={this.isEmptyDay()}>{this.props.dayName}</button>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch<FestivalOverviewAppState>): DispatchToProps {
    return {
        getFestivalSeries: (day: string) => dispatch(getFestivalSeries(day))
    }
}

function mapStateToProps(state: FestivalOverviewAppState): StateToProps {
    return {
        currentDay: state.festivalOverviewApiModel.currentDay,
        emptyDayList: state.festivalOverviewSettingsModel.emptyDayList
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DayItemComponent);